import * as R from 'ramda'
import { ComponentEnhancer, compose, withHandlers, withState } from 'recompose'

export type WithShowFeedback = {
  feedback: string
  showFeedback(feedback: string)
}

export const withFeedback = <T>(timeoutMs = 500): ComponentEnhancer<T & WithShowFeedback, T> => {
  let feedbackTimeout

  return compose<any, any>(
    withState('feedback', 'setFeedback', 'none'),
    withHandlers({
      showFeedback: ({ setFeedback }) => feedbackType => {
        if (!R.isNil(feedbackTimeout)) {
          clearTimeout(feedbackTimeout)
        }
        setFeedback(feedbackType)

        return new Promise<void>(resolve => {
          feedbackTimeout = setTimeout(() => {
            setFeedback('none')
            resolve()
          }, timeoutMs)
        })
      },
    }),
  )
}



// WEBPACK FOOTER //
// ./src/components/higher-order/feedback.ts